'use strict';
var productJqueryHelper = require('./productJqueryHelper');
var gallery = require('./gallery');
var bs = require('../thirdParty/bootstrap');
// var owlThumbs = require('../thirdParty/owl.carousel2.thumbs');

module.exports = {

    galleryInit: gallery.init,

    availability: productJqueryHelper.availability,

    addToCart: productJqueryHelper.addToCart,
    quantityChange: productJqueryHelper.quantityChange,
    owlCarousel: productJqueryHelper.owlCarousel,
    
    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            // if (data.shortDescription) {
            //     $productContainer.find('.description-and-detail .description')
            //         .removeClass('hidden-xl-down');
            //     $productContainer.find('.description-and-detail .description .content')
            //         .empty()
            //         .html(data.shortDescription);
            // } else {
            //     $productContainer.find('.description-and-detail .description')
            //         .addClass('hidden-xl-down');
            // }

            // if (data.longDescription) {
            //     $productContainer.find('.description-and-detail .details')
            //         .removeClass('hidden-xl-down');
            //     $productContainer.find('.description-and-detail .details .content')
            //         .empty()
            //         .html(data.longDescription);
            // } else {
            //     $productContainer.find('.description-and-detail .details')
            //         .addClass('hidden-xl-down');
            // }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            
            if(response.hasOwnProperty("resource")){
            	var addToBasketText = response.resource.addToCart_inStock;
            	
            	if(response.product.readyToOrder && !response.product.available && response.product.customAttributes.discontinued){
            		addToBasketText = response.resource.addToCart_discontinued;
            	}else if(response.product.readyToOrder && !response.product.available){
            		addToBasketText = response.resource.addToCart_outOfStock;
            	}else if(response.product.availability.fewLeft){
            		addToBasketText += " " + response.resource.addToCart_fewLeft;
            	}
            	
            	$('button.add-to-cart').html(addToBasketText);
            }
            
            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $('button.add-to-cart-global').attr('disabled', !enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            var onlineInv = $('.online-inventory-status .inventory-status');
            if (onlineInv.length && response.product.availability && response.product.availability.stockMessages){
                onlineInv.find('img').attr('src', response.product.availability.stockMessages.onlineImage);
                onlineInv.find('span').empty().text(response.product.availability.stockMessages.onlineMessage);
            }

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    //Product details: Show more 
    toggleShowMore: function () {
        $('body').on('click', '.description-and-detail .expandable .show-more', function () {
            event.preventDefault();
            $('.description-and-detail .expandable').removeClass('collapsed');
        });
    },

    onloadCalls: $(function () {
        // Product details: Show more toggle
        if ($('.description-and-detail .expandable .content-wrapper').height() > 93) {
            $('.description-and-detail .expandable').addClass('collapsed');
        }
     }),

    focusChooseBonusProductModal: productJqueryHelper.focusChooseBonusProductModal()
};

